import { styled } from '@mui/material';
import { RouteComponentProps, Router } from '@reach/router';
import { PolicyStreamAdminHub } from './PolicyStream/PolicyStreamAdminHub';
import { PolicyStreamPlansAdminPage } from './PolicyStream/PolicyStreamPlansAdminPage';
import { PolicyStreamPlanDetailAdminPage } from './PolicyStream/PolicyStreamPlanDetailAdminPage';
import { CompulifeApiCallsAdminPage } from './PolicyStream/CompulifeApiCallsAdminPage';
import { CompulifeApiCallDetailAdminPage } from './PolicyStream/CompulifeApiCallDetailAdminPage';

interface PolicyStreamPageProps extends RouteComponentProps {}

export const PolicyStreamPage = (_props: PolicyStreamPageProps) => {
  return (
    <PolicyStreamPageContainer>
      <Router primary={false}>
        <PolicyStreamAdminHub default />
        <PolicyStreamPlansAdminPage path='plans' />
        <PolicyStreamPlanDetailAdminPage path='plans/:planId' />
        <CompulifeApiCallsAdminPage path='compulifecalls' />
        <CompulifeApiCallDetailAdminPage path='compulifecalls/:callId' />
      </Router>
    </PolicyStreamPageContainer>
  );
};

const PolicyStreamPageContainer = styled('div')(({ theme }) => {
  return {
    padding: theme.spacing(3),
  };
});
